import SPlayer from "@/Master/SPlayer";
import { useRouter } from "next/navigation";
import {StartManager} from "@/Core/StartManager";
import DuMgr from "@/Fwk/SM/DuMgr";
import WindowGlobal from "@/app/WindowGlobal";
import UtilUnity from "@/app/(game)/unity-game/UtilUnity";
import Util from "@/Master/Util";

export default class MainScene {
    private static router: any;
    static onInit(){
        this.router = useRouter();
        SPlayer.checkInit();
        StartManager.onStart();
    }

    static onEnter(){
        DuMgr.Init();
        UtilUnity.Init()

    }

    static onUpdate(){

    }

    static onDestroy()
    {

    }




}